module.exports = function() {
  return new Worker("/" + "download.worker.cb069004e9ace5f89e8e.js");
};